<div *ngFor="let navitem of parentChildRoutes" [routerLinkActive]="['link-active']" class="side-nav-item">
    <a [routerLink]="['', parentRoute, navitem.path]">
        <span *ngIf="navitem.data.svgIcon" [inlineSVG]="navitem.data.svgIcon + '.svg'" class="item-icon"></span>
        <span class="item-text">
      {{ navitem.data.showInSideNavAs }}
    </span>
    </a>
</div>
